import { render, staticRenderFns } from "./AlternateOptionCondensed.vue?vue&type=template&id=6504651b&scoped=true"
import script from "./AlternateOptionCondensed.vue?vue&type=script&lang=js"
export * from "./AlternateOptionCondensed.vue?vue&type=script&lang=js"
import style0 from "./AlternateOptionCondensed.vue?vue&type=style&index=0&id=6504651b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6504651b",
  null
  
)

export default component.exports